// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
// 动态修改title vue-wechat-title
import VueWechatTitle from 'vue-wechat-title'
import App from './App'
import router from './router'
import store from './store'
import './utils/filter'
import './utils/index'
import axios from 'axios'
import './assets/css/resetvant.less'
import global from './global.js'
import Vconsole from 'vconsole'
// 使用调试工具
// const vConsole = new Vconsole()
// Vue.use(vConsole)

// 导入vant UI库
import Vant from 'vant'
import 'vant/lib/index.css'

// 图片懒加载
import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload, {
  preLoad: 1.3,
  attempt: 1,
})

// 使用VueWechatTitle
Vue.use(VueWechatTitle)

// 全局参数配置
Vue.prototype.globalParams = global
// 带参数的使用
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: 'dist/error.png',
  loading: 'dist/loading.gif',
  attempt: 1
})

Vue.config.productionTip = false
// 使用全局参数
// this.globalParam.HTTP_API_URL

// 配置接口地址
// 当路由跳转页面后，返回顶部
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0)
  setTimeout(() => {
    // 百度统计---------------------------------------------start
    // eslint-disable-next-line no-use-before-define
    var _hmt = _hmt || []
    // 必须把_hmt挂载到window下，否则找不到
    window._hmt = _hmt
    // histroy模式
    window._hmt.push(['_trackPageview', to.fullPath]);
    (function () {
    // 每次执行前，先移除上次插入的代码
      document.getElementById('baidu_tj') && document.getElementById('baidu_tj').remove()
      var hm = document.createElement('script')
      hm.src = 'https://hm.baidu.com/hm.js?f94255426a62809cfe6cd01f17c21b81'
      hm.id = 'baidu_tj'
      var s = document.getElementsByTagName('script')[0]
      s.parentNode.insertBefore(hm, s)
    })()
    // 百度统计---------------------------------------------end
  }, 0)
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js